<template>
    <div class="Seguro-Colectivo-Salud">
        <div class="title">
                <span>Seguros</span>
                <h1>Personales y Familia</h1>
                <div id="contactForm">
                    <label for="">Conoce más sobre soluciones de seguros</label>
                    <div id="hubcontactForm"></div>
                </div>
        </div>
        <div class="info">
                <h1>Plan Inversión Protegida</h1>
                <p>
                Soñar con tu proyecto de vivienda te llena de emoción, pero la felicidad de hacerlo realidad no se compara con nada.
                </p>
        </div>
        <div class="texto">
            <center class="box">
                <p>Sabemos que tener vivienda propia es uno de tus sueños y  nos encargamos de cuidar la inversión que hagas para hacerlo realidad. De esa manera no te preocupas por las diferentes
                eventualidades que pongan en riesgo tu patrimonio y tu esfuerzo.
                <br>
                <br>
                Con el Plan Inversión Protegida garantizas el pago de la cuota inicial de tu vivienda ante el constructor o la entidad financiera si pierdes tu empleo, quedas inválido o falleces.
                <br>
                <br>
                ¡Permítenos acompañarte para que cumplas tu meta de tener vivienda propia, sea para habitar o invertir!
                </p>
            </center>
        </div>
        <div class="texto">
            <center><label for="">Este plan cubre desde la primera cuota hasta el crédito total en caso de:</label></center>
            <center class="box">
                <p>
                <span>Desempleo o pérdida del ingreso por incapacidad</span>
                <br>
                <br>
                Si tienes contrato individual de trabajo (no incluye la relación legal o reglamentaria con el Estado): si eres despedido o desvinculado
                por decisión del empleador sin justa causa, Se paga al beneficiario oneroso seis cuotas de tu deuda.
                <br>
                <br>
                Si eres un trabajador independiente y tu EPS o ARL te incapacitan temporalmente para trabajar por más de 14 días: como
                consecuencia de un accidente o enfermedad, Se paga al beneficiario oneroso el número de cuotas a las que tiene derecho. El pago
                depende de los días de incapacidad que tuviste.
                <br>
                <br>
                <span>Incapacidad total y permanente</span>
                <br>
                <br>
                Si como consecuencia de un accidente o una enfermedad quedas inválido, es decir, pierdes de forma permanente el 50 % o más de
                tu capacidad laboral, Se paga al beneficiario, con el que tienes la deuda, el valor asegurado. Si al pagar este saldo no se agota todo el
                valor asegurado, la parte restante de este se te entrega.
                <br>
                <br>
                <span>Fallecimiento</span>
                <br>
                <br>
                En caso de muerte, Se paga al beneficiario oneroso con el que tienes la deuda el monto que no hayas alcanzado a pagar, sin que este
                supere el valor asegurado. Si al pagar este saldo no se agota todo el valor asegurado, la parte restante se entrega a los beneficiarios
                que hayas designado libremente o a los de ley.
                </p>
            </center>
        </div>
        <div class="texto">
            <center><h1>¿Qué no cubre?</h1></center>
            <center class="box">
                <p>
                Algunas de las exclusiones de este seguro son:
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Enfermedades o accidentes ocurridos antes de la contratación del seguro.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Terminación del contrato por despido del empleador con justa causa.
                <br>
                <br>
                <font-awesome-icon class="facirclecheck-service" icon="fa-check" size="2x"/>Si practicas constantemente deportes de alto riesgo como parapentismo, escalada de montaña, puenting, entre otros.
                </p>
            </center>
        </div>
        <div class="move"><center><img src="@/assets/Seguro-de-mascotas/4.png" alt=""></center></div>
        <Aliados/>
    </div>
</template>

<script>
import Aliados from '../../utilitis/aliados'
import VueSlickCarousel from 'vue-slick-carousel'

export default {
    name: 'Seguro-Colectivo-salud',
    components: {
        Aliados,
        VueSlickCarousel
    },
    data() {
        return {
            services: [
                {
                    type: true,
                    img: require('@/assets/Servicio1.png'),
                    label: '¿Qué cubre?'
                }
            ],
            coberturaOpcional: [
                {
                    label: 'Muerte accidental',
                    p: 'Si falleces en un accidente o como producto de él, siempre y cuando la muerte ocurra dentro de los 180 días siguientes al hecho, les daremos a tus beneficiarios una indemnización por el valor que contrataste desde un principio.'
                },
                {
                    label: 'Invalidez, desmembración o inutilización por accidente',
                    p: 'En caso sufrir un accidente en el que termines con alguna invalidez total o pérdida funcional de ciertos órganos o partes de tu cuerpo, te daremos una indemnización equivalente al porcentaje de invalidez, de esa manera conservas tu independencia económica y sostienes los gastos que pueda traer consigo este hecho.'
                }
            ],
            slickOptionsExperiencies: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': true,
                'infinite': true,
                'autoplay': true,
                'autoplaySpeed': 3000,
                'speed': 500,
                'slidesToShow': 3,
                'slidesToScroll': 3,
                'touchThreshold': 5,
                'responsive': [
                    {
                        'breakpoint': 1140,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'infinite': true
                        }
                    },
                    {
                        'breakpoint': 680,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                            'infinite': true
                        }
                    }
                ]
            },
            especialidades: [
                {
                    image: require('@/assets/Accidentes-personales/1.png'),
                    texto: 'Estar tranquilo porque tus beneficiarios recibirán una indemnización en caso de que fallezcas en un accidente o como consecuencia de este.'
                },
                {
                    image: require('@/assets/Accidentes-personales/2.png'),
                    texto: 'Recibir una renta diaria durante el tiempo que tarde tu recuperación para que tú y tus seres queridos no pierdan su calidad de vida.'
                },
                {
                    image: require('@/assets/Accidentes-personales/3.png'),
                    texto: 'Contar con apoyo económico si quedas con una invalidez o desmembración a causa de un accidente.'
                },
                {
                    image: require('@/assets/Accidentes-personales/4.png'),
                    texto: 'Tener la posibilidad de recibir reembolsos por los gastos médicos en que incurras a consecuencia de un accidente.'
                }
            ]
        }
    },
    beforeMount() {
        this.$root.$emit('change_url', this.$route.name)
    },
    mounted() {
        window.hbspt.forms.create({
            region: 'na1',
            portalId: '5573496',
            formId: '4cd61e34-58c1-4068-accb-dae3eeb5e789',
            target: '#hubcontactForm'
        })
    }
}
</script>
<style>
    .cobertura-principal-slide > p > span {
        font-weight: bold;
        margin-left: 5em;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 25px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-principal > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots {
        z-index: 99999999;
        bottom: 5px;
        margin-bottom: 15px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li {
        width: 30px;
        height: 1px;
        list-style-type: none;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots > li > button {
        border: 0px;
        border-style: solid;
        border-color:#2d4f98;
        color: #2d4f98;
        background-color: #2d4f98;
        width: 100%;
        height: 5px;
        list-style-type: none;
        padding: 0;
        border-radius: 5px;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:before {
        content: none;
        padding: 0;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:hover{
        border-color:#2d4f98;
        color: #2d4f98;
    }
    .slide-cobertura-opcional > .slick-slider > .slick-dots li button:active{
        background-color: #000;
    }
</style>

<style scoped>
    .title {
        background-image: url('../../../assets/servicios-bg-personas-familias.png');
        padding: 200px 300px;
        color: #fff;
        background-position: center;
        background-repeat: no-repeat;
    }
    .title > span {
        font-family: 'JLI';
        font-size: 40px;
    }
    .title > h1 {
        font-family: 'JBD';
        font-size: 50px;
    }
    #contactForm {
        margin-top: -100px;
        font-family: 'JR';
        background-color: #fff;
        padding: 40px;
        position: absolute;
        border-radius: 10px;
        width: 400px;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        font-weight: bolder;
        right: 100px;
    }
    #contactForm > label {
        color: #65b24a;
        font-size: 24px;
        line-height: 25px;
    }
    .info {
        padding: 100px 0px;
    }
    .info > h1 {
        font-family: 'JBD';
        color: #65b24a;
        padding-left: 300px;
        font-size: 40px;
        width: 60%;
    }
    .info > p {
        font-family: 'JR';
        width: 60%;
        padding-left: 300px;
        margin-top: 10px;
        font-size: 18px;
    }
    .slider2 {
        width: 70%;
    }
    .especialidades-slide{
        padding-top: 40px;
    }
    .especialidades-slide > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
        font-size: 30px;
    }
    .especialidades > div {
        height: 500px;
    }
    .especial img {
        width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    .especial > p {
        font-family: 'JR';
        padding: 10px;
        text-align: left;
    }
    .texto {
        width: 100%;
        padding: 10px 300px;
    }
    .texto > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box-title {
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .texto > .box-title > h1 {
        color: #2d4f98;
        font-family: 'JBD';
    }
    .texto > .box {
        padding: 20px 20px;
        text-align: left;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        margin-bottom: 10px;
    }
    .texto > center > label {
        font-family: 'JBD';
        color: #65b24a;
    }
    .texto > center > p {
        font-family: 'JR';
    }
    .texto > center > p > span{
        font-weight: bold;
        color: #2d4f98;
    }
    .service {
        padding: 20px 300px;
        width: 100%;
    }
    .service > div {
        width: 100%;
        margin-top: 20px;
    }
    .service > div {
        width: 100%;
        display: flex;
    }
    .service > div > div > img {
        width: 350px;
        float: left;
    }
    .service > div > .imgbox {
        display: block;
        width: 350px;
        z-index: 99999;
    }
    .service > div > .box {
        margin-left: -300px;
        margin-top: 110px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 30px 30px 350px;
    }
    .service > div > .box > div > img {
        width: 70px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .service > div > .box > label {
        font-weight: bold;
        padding: 20px;
    }
    .service > div > .box > div > label {
        font-family: 'JBD';
        color: #65b24a;
    }
    .service > div > .box2 {
        margin-right: -300px;
        margin-top: 60px;
        background-color: #fff;
        -webkit-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        -moz-box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        box-shadow: 10px 10px 26px 0px rgba(0,0,0,0.07);
        width: 92%;
        height: auto;
        padding: 30px 350px 100px 30px;
    }
    .service > div > .right{
        position: absolute;
        right: 15%;
    }
    .service > div > .box > h1 {
        position: relative;
        font-family: 'JBD';
        color:#2d4f98;
        margin-top: -120px;
        margin-bottom: 60px;
        text-align: left;
    }
    .service > div > .box > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box2 > h1 {
        position: relative;
        font-family: 'JBD';
        color: #2d4f98;
        margin-bottom: 10px;
        margin-top: -120px;
        text-align: right;
        margin-bottom: 60px;
    }
    .service > div > .box2 > div > div {
        font-family: 'JR';
        margin-bottom: 15px;
    }
    .service > div > .box > div > div > p > span{
        color:#65b24a;
        font-family: 'JBD';
    }
    .facirclecheck-service {
        margin-right: 4px;
        margin-top: 4px;
        font-weight: bolder;
        color: #2d4f98;
        width: 15px;
        height: 15px;
        float: left;
    }
    .cobertura-principal {
        width: 100%;
        padding: 0px 300px;
    }
    .cobertura-principal > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
    }
    .cobertura-principal > div {
        display: flex;
        margin-bottom: 50px;
    }
    .cobertura-principal > div > center > img {
        width: 200px;
        height: auto;
    }
    .cobertura-principal > div > div {
        padding: 20px;
    }
    .cobertura-principal > div > div > div > img{
        width: 50px;
        margin-right: 20px;
    }
    .cobertura-principal > div > div > div > label{
        font-family: 'JBD';
        color: #65b24a;
        font-size: 20px;
    }
    .cobertura-principal > div > div {
        padding: 25px;
        margin-top: 20px;
        font-family: 'JR';
        -webkit-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        -moz-box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
        box-shadow: 10px 10px 26px 26px rgba(0,0,0,0.04);
    }
    .cobertura-principal-slide{
        padding: 0px 300px;
    }
    .cobertura-principal-slide > div {
        display: flex;
    }
    .cobertura-principal-slide > div > label {
        color: #65b24a;
        font-family: 'JBD';
        font-size: 20px;
    }
    .cobertura-principal-slide > div > img {
        width: 50px;
    }
    .cobertura-principal-slide > p {
        font-family: 'JR';
        margin-top: 10px;
        margin-bottom: 60px;
    }
    .slide-cobertura-opcional > center > label {
        color: #65b24a;
        font-family: 'JBD';
    }
    .slide-cobertura-opcional > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-top: 50px;
        margin-bottom: 50px;
    }
    .ofrecemos {
        padding: 50px 300px;
    }
    .ofrecemos > center > h1 {
        font-family: 'JBD';
        color: #2d4f98;
    }
    .ofrecemos > label {
        color: #65b24a;
        font-family: 'JBD';
    }
    .opcionales {
        padding: 50px 300px;
        font-family: 'JR';
    }
    .opcionales > center > h1 {
        color: #2d4f98;
        font-family: 'JBD';
        margin-bottom: 20px;
    }
    .opcionales > .opcional > .subopcional {
        padding-left: 50px;
    }
    .connect {
        background: -prefix-linear-gradient(left, #2d4f98, #65b24a);
        background: linear-gradient(to right, #2d4f98 30%, #65b24a);
        height: 200px;
        width: 100%;
    }
    .connect > img {
        position: absolute;
        height: 200px;
        width: 380px;
        right: 0;
        object-fit: cover;
        object-position: 75px -70px;
    }
    .connect > h1 {
        font-family: 'JBD';
        padding-top: 50px;
        padding-left: 200px;
        color: #65b24a;
    }
    .connect > p{
        font-family: 'JR';
        padding-left: 200px;
        width: 80%;
        color: #fff;
        font-size: 22px;
        line-height: 25px;
    }
    .move > center > img {
        margin-top: 30px;
        width: 800px;
    }
    @media (max-width: 1600px) {
        .slider2 {
            width: 60%;
        }
    }
    @media (max-width: 1500px) {
        .title {
            padding: 200px 200px;
        }
        .info > h1 {
            padding-left: 200px;
        }
        .info > p {
            padding-left: 200px;
        }
        .slider2 {
            width: 65%;
        }
    }
    @media (max-width: 1400px) {
        .title {
            padding: 200px 100px;
        }
        .info > h1 {
            padding-left: 100px;
        }
        .info > p {
            padding-left: 100px;
        }
        .services {
            padding: 50px 100px;
            width: 100%;
        }
        .service {
            padding: 20px 150px;
            width: 100%;
        }
        .slider2 {
            width: 70%;
        }
    }
    @media (max-width: 1300px) {
        .info > h1 {
            font-size: 30px;
        }
        .info > p {
            width: 50%;
        }
        .texto {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 200px;
        }
        .cobertura-principal-slide{
            padding: 0px 200px;
        }
        .opcionales {
            padding: 50px 200px;
        }
        .ofrecemos {
            padding: 50px 200px;
        }
        .slider2 {
            width: 75%;
        }
    }
    @media (max-width: 1200px) {
        .service {
            padding: 20px 75px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 10%;
        }
    }
    @media (max-width: 1100px) {
        .service {
            padding: 20px 50px;
            width: 100%;
        }
        .service > div > .right{
            position: absolute;
            right: 5%;
        }
        .connect > h1 {
            padding-top: 10px;
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        .connect > p{
            padding-left: 100px;
            z-index: 99999999;
            position: sticky;
        }
        #contactForm {
            margin-top: -100px;
            right: 50px;
        }
        .slider2 {
            width: 80%;
        }
    }
    @media (max-width: 1000px) {
        .title {
            padding: 50px 0px;
            height: 400px;
            text-align: center;
        }
        #contactForm {
            margin-top: 10px;
            left: 0;
            right: 0;
            margin: auto;
        }
        .info {
            padding-top: 400px;
            width: 100%;
            text-align: center;
        }
        .info > h1 {
            width: 100%;
            padding: 10px;
            text-align: center;
        }
        .info > p {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
        .texto {
            width: 100%;
            padding: 10px 100px;
        }
        .services {
            padding: 0px 50px;
        }
        .service {
            padding: 20px 25px;
            width: 100%;
        }
        .connect > h1 {
            padding-left: 50px;
            font-size: 30px;
        }
        .connect > p{
            padding-left: 50px;
            font-size: 18px;
        }
        .cobertura-principal {
            width: 100%;
            padding: 10px 100px;
        }
        .cobertura-principal-slide{
            padding: 0px 100px;
        }
        .opcionales {
            padding: 50px 100px;
        }
        .ofrecemos {
            padding: 50px 100px;
        }
    }
    @media (max-width: 900px) {
        .colectivo > center > div {
            display: block;
        }
        .move > center > img {
            width: 700px;
        }
    }
    @media (max-width: 800px) {
        .services > center > div > div {
            display: block;
            width: 60%;
            float: none;
        }
        .service > div {
            display: grid;
        }
        .service > div > .box{
            margin-left: 0px;
            margin-top: 0px;
            width: 100%;
            padding: 30px 30px 30px 30px;
        }
        .service > div > .box2 {
            margin-right: 0px;
            margin-top: 0px;
            background-color: #fff;
            width: 100%;
            padding: 30px 30px 100px 30px;
        }
        .service > div > .imgbox {
            display: block;
            width: 100%;
            display: flex;
            justify-content: center;
        }
        .service > div > .imgbox > img{
            width: 250px;
            margin: auto;
        }
        .service > div > .right{
            position: relative;
            right: 0px;
        }
        .service > div > .box2 > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .service > div > .box > h1 {
            margin-top: 0px;
            margin-bottom: 20px;
            text-align: left;
        }
        .cobertura-principal > div {
            display: block;
        }
        .move > center > img {
            width: 600px;
        }
    }
    @media (max-width: 700px) {
        .texto {
            width: 100%;
            padding: 10px 50px;
        }
        .cobertura-principal {
            padding: 10px 50px;
        }
        .cobertura-principal-slide {
            padding: 0px 50px;
        }
        .opcionales {
            padding: 50px 50px;
        }
        .ofrecemos {
            padding: 50px 50px;
        }
        .move > center > img {
            width: 500px;
        }
    }
    @media (max-width: 600px) {
        .connect > h1 {
            font-size: 18px;
        }
        .connect > p{
            font-size: 18px;
            width: 100%;
        }
        .services > center > div > div {
            width: 70%;
        }
        .move > center > img {
            width: 400px;
        }
    }
    @media (max-width: 500px) {
        .texto > .box-title > h1 {
            font-size: 30px;
        }
        #contactForm {
            width: 300px;
        }
        .connect > h1 {
            padding-left: 25px;
        }
        .connect > p{
            padding-left: 25px;
        }
        .services > center > div > div {
            width: 80%;
        }
        .slide-cobertura-opcional > center > h1 {
            font-size: 30px;
        }
        .cobertura-principal > center > h1{
            font-size: 30px;
        }
        .opcionales > center > h1 {
            font-size: 30px;
        }
        .ofrecemos > center > h1 {
            font-size: 30px;
        }
        .move > center > img {
            width: 300px;
        }
    }
    @media (max-width: 400px) {
        .services > center > div > div {
            width: 90%;
        }
        .connect > p{
            padding-left: 5px;
            font-size: 16px;
            line-height: 19px;
        }
        .move > center > img {
            width: 250px;
        }
        .especial img {
            width: 240px;
        }
        .cobertura-principal > div > div {
            padding: 20px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Servicios/ServiciosPersonas/PlanInversion.vue